
import axios from "axios";
import { GET_DIAGNOSIS_FAIL, GET_DIAGNOSIS_REQUEST, GET_DIAGNOSIS_SUCCESS } from "../constants/Diagnosis";
import { baseUrl } from "./baseUrl";

export const Diagnosis = (patient) => async (dispatch) => {
    try {
        dispatch({
            type: GET_DIAGNOSIS_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "Application/json",
                "Authorization": "Bearer " + window.atob(JSON.parse(localStorage.getItem('md_btn_mi_sas'))),
            },
        };
        const { data } = await axios.get(
            `${baseUrl}/diagnosis?patient=${patient}`,
            config
        );

        dispatch({
            type: GET_DIAGNOSIS_SUCCESS,
            payload: data,
        });

    } catch (err) {
        let message =
            err.response && err.response.data.errors
                ? err.response.data.errors
                : err.message;
        dispatch({
            type: GET_DIAGNOSIS_FAIL,
            payload: message,
        });

    }
};


